import classNames from "classnames";

/**
 * Shared class strings for the Menu's floating panel and rows — the single
 * source of truth for the Claude Design menu look. Other menu-like surfaces
 * (e.g. the table's filter-v2 dropdown, whose grammar the Menu was lifted
 * from) import these so the two stay pixel-consistent.
 */

export const MENU_PANEL_CLASSES = classNames(
  "z-[1000] min-w-[248px] p-1.5",
  "bg-page border border-divider rounded-lg shadow-panel-lift",
  "font-sans",
  "motion-safe:data-[state=open]:animate-menu-in",
);

export const MENU_ITEM_BASE_CLASSES = classNames(
  "group flex min-h-target items-center gap-2.5 rounded-md px-2.5 py-2",
  "text-sm leading-tight select-none outline-none",
  "cursor-pointer transition-colors duration-100",
  "data-[disabled]:opacity-45 data-[disabled]:cursor-not-allowed",
);

export const MENU_ITEM_TONE_CLASSES = classNames(
  "text-default",
  "data-[highlighted]:bg-tint data-[highlighted]:text-primary",
);

export const MENU_ITEM_CLASSES = classNames(
  MENU_ITEM_BASE_CLASSES,
  MENU_ITEM_TONE_CLASSES,
);

export const MENU_DANGER_ITEM_CLASSES = classNames(
  "text-danger",
  "data-[highlighted]:bg-danger-subtle data-[highlighted]:text-danger",
);

export const MENU_ICON_SLOT_BASE_CLASSES = classNames(
  "w-5 h-5 shrink-0 grid place-items-center",
  "transition-colors duration-100",
);

export const MENU_ICON_SLOT_TONE_CLASSES = classNames(
  "text-muted",
  "group-data-[highlighted]:text-primary",
);

export const MENU_ICON_SLOT_CLASSES = classNames(
  MENU_ICON_SLOT_BASE_CLASSES,
  MENU_ICON_SLOT_TONE_CLASSES,
);

export const MENU_DANGER_ICON_SLOT_CLASSES = classNames(
  "text-danger group-data-[highlighted]:text-danger",
);

export const MENU_SEPARATOR_CLASSES = "h-px bg-raised my-[5px] mx-1";

export const MENU_LABEL_CLASSES = classNames(
  "px-2.5 pt-2 pb-1",
  "text-[0.6875rem] font-semibold uppercase tracking-wider text-muted",
);
